import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Novo from './Novo'
import Editar from './Editar'

const route = {
  path: '/usuarios-ponto-apoio',
  name: 'usuarios-ponto-apoio',
  component: Index,
  children: [
    { path: 'listar', name: 'usuarios-ponto-apoio-listar', component: Listar },
    { path: 'novo', name: 'usuarios-ponto-apoio-novo', component: Novo },
    { path: ':id', name: 'usuarios-ponto-apoio-detalhes', component: Detalhes, props: true },
    { path: ':id/e', name: 'usuarios-ponto-apoio-editar', component: Editar, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/usuarios-ponto-apoio/routes.js